import { render, staticRenderFns } from "./S1_P2_Contracts.vue?vue&type=template&id=f88ee9d4&scoped=true&"
import script from "./S1_P2_Contracts.vue?vue&type=script&lang=js&"
export * from "./S1_P2_Contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ee9d4",
  null
  
)

export default component.exports